<template>
  <section class="">
   <form @submit.prevent="register">
    <div class="left"><img style="float: right; margin-top: -100px;" src="/img/top_ds_left.png"></div><div class="content bcgd">
     <div class="row">
      <p class="brief">Поля, отмеченные (*) обязательны для заполнения</p>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <label for="company">Компания</label>
          <input id="conpany" v-model="company" required autofocus>
          <label for="fname">Имя*</label>
          <input id="fname" v-model="name" required />
          <label for="lname">Фамилия*</label>
          <input id="lname" v-model="lname" required>
          <label for="email">Ваш e-mail*</label>
          <input id="email" v-model="email" required>
          <label for="phone">Номер телефона*</label>
          <input id="phone" v-model="phone" required>
          <label for="login">Ваш логин*</label>
          <input id="login" v-model="login" required>
          <label for="password">Придумайте пароль*</label>
          <input id="password" v-model="password" required typea="password">
          <label for="password_confirmation">Повторите пароль*</label>
          <input id="password_confirmation" v-model="password_confirmation" required typea="password">
          <button class="button" value="">Зарегистрироваться</button>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <label><b>ИНФОРМАЦИЯ О НАС</b></label>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
        aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis
        aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
        occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
      </div></div>
    </div><div class="right"><img style="float: left; margin-top: -300px;" src="/img/top_ds_right.png"></div>
    <div class="iskaut"></div><div class="iskaut-revers"></div>
   </form>
  </section>
</template>
<script>
    export default {
        data(){
            return {
                name : "",
		lname: "",
                email : "",
		phone: "",
                password : "",
                password_confirmation : "",
		login: "",
                is_admin : null
            }
        },
        methods: {
            register: function () {
                let data = {
                    name: this.name,
                    lname: this.lname,
                    email: this.email,
                    phone: this.phone,
                    login: this.login,
                    password: this.password,
                    is_admin: this.is_admin
                }
                this.$store.dispatch('register', data)
               .then(() => this.$router.push('/'))
               .catch(err => console.log(err))
            }
        }
    }
</script>
